import React from 'react';

const SpeakerDashboard = () => {
  return (
    <div className="container section">
      <h1>Speaker Dashboard</h1>
      <p>Your speaker dashboard will appear here.</p>
    </div>
  );
};

export default SpeakerDashboard;
